import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Tooltip, Button, Modal, Divider, message } from "antd";
import { QuestionCircleOutlined, DownloadOutlined, CloseOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { format, findDeep, getReleaseDetail } from "@/utils";
import api from "@/api";
import { publicPath } from "@/utils/base";

const { confirm } = Modal;
import dataJson from "@/../public/data.json";

const prefix = "appDetail-info";
import "./index.less";


function Info() {
  const { app_detail, confirmText, cancelText, staging, release, req_err, de, delete_text } = dataJson;

  const [application, setApplication] = useState<any>();

  const navigate = useNavigate();
  const { type, id } = useParams();

  const releaseDetail = useSelector((state: any) => state.releaseDetail);

  const typeObj: any = app_detail.type_obj;
  const typeItem = typeObj[type!];

  const isComponent = type === staging.my_tabs[1].typeKey;

  const handleDelete = () => {
    confirm({
      title: delete_text + application?.tpyeName,
      icon: null,
      width: 328,
      centered: true,
      closable: true,
      closeIcon: <CloseOutlined />,
      okText: confirmText,
      cancelText: cancelText,
      content: (
        <div className="delete-modal-content">
          {app_detail.app_delete_content1}&quot;{application.packageName}&quot;{de}
          {application?.tpyeName}
          {app_detail.app_delete_content2}
        </div>
      ),
      onOk: async () => {
        try {
          const res: any = await api[typeItem.deleteApi]({ ids: [id] });

          if (res?.code == 200) {
            navigate(`${publicPath}staging`);
          } else {
            window.message.error(res.msg);
          }
        } catch (errorInfo: any) {
          console.error(errorInfo);
        }
      },
    });
  };

  const handleDownload = async () => {
    const res: any = await api.defaultPrivate({ path: app_detail.kit_download_api });
    if (res.code === 200) {
      window.open(res.data, "_self");
    } else {
      window.message.error(res.msg || req_err);
    }
  };

  useEffect(() => {
    if (releaseDetail) {
      const isDel = releaseDetail.histories.every((item: any) => {
        const resShowMode = findDeep(release.show_mode_arr, item.showMode);
        return resShowMode?.baseBtns?.includes("delete");
      });

      const resDataCopy = {
        ...releaseDetail,
        packageType: typeItem.subType.join("/"),
        createTimeText: format(new Date(Number(releaseDetail?.createTime)), "yyyy年MM月dd日 HH:mm:ss"),
        tpyeName: typeItem.completeLabel,
        isDel,
      };

      setApplication(resDataCopy);
    }
  }, [releaseDetail]);

  useEffect(() => {
    getReleaseDetail(type, id);
  }, []);

  return (
    <div className={prefix}>
      <div className={`${prefix}-inner`}>
        <div className={`${prefix}-header`}>
          <div className={`${prefix}-header-text`}>
            <div className={`${prefix}-header-title`}>
              {(isComponent ? typeItem?.completeLabel : typeItem?.typeName) + app_detail.info_text}
            </div>
            <div className={`${prefix}-header-tip`}>
              {(isComponent ? typeItem?.completeLabel : typeItem?.typeName) + app_detail.app_info_tip}
            </div>
          </div>
          <div className={`${prefix}-header-btns`}>
            <Button
              type="primary"
              className={`${prefix}-content-delete`}
              disabled={!application?.isDel}
              onClick={handleDelete}
            >
              {delete_text + typeItem?.typeName}
            </Button>
          </div>
        </div>
        <div className={`${prefix}-content`}>
          <div className={`${prefix}-content-title`}>{app_detail.developer_title}</div>
          <div className={`${prefix}-content-developer`}>
            <Tooltip
              placement="bottomLeft"
              title={app_detail.developer_tip1 + typeItem?.typeName + app_detail.developer_tip2}
              overlayClassName={`${prefix}-content-developer-tooltip`}
              color="#fff"
              overlayInnerStyle={{
                color: "rgba(0,0,0,0.8)",
                width: 200,
                padding: "10px 16px",
                transform: "translate(-12px, 0)",
              }}
            >
              <QuestionCircleOutlined style={{ color: "#0A59F7", cursor: "pointer", fontSize: 14 }} />
            </Tooltip>
            <div className={`${prefix}-content-developer-id`}>
              <span>{app_detail.developer_ID}</span>
              {application?.developerId}
            </div>
          </div>
          <Divider />
          <div className={`${prefix}-content-title mt-title`}>
            {isComponent ? typeItem?.completeLabel : typeItem?.typeName}
          </div>
          {isComponent ? null : (
            <div className={`${prefix}-content-value`}>
              <span>{app_detail.app_type}</span>
              {application?.tpyeName}
            </div>
          )}
          <div className={`${prefix}-content-value`}>
            <span>{app_detail.package_type}</span>
            {application?.packageType}
          </div>
          <div className={`${prefix}-content-value`}>
            <span>{app_detail.package_name}</span>
            {application?.packageName}
          </div>
          <div className={`${prefix}-content-value`}>
            <span>{isComponent ? app_detail.component_id : app_detail.app_id}</span>
            {application?.appId}
          </div>
          <div className={`${prefix}-content-value`}>
            <span>{app_detail.create_time}</span>
            {application?.createTimeText}
          </div>

          {["1", "2", "3"].includes(type!) ? (
            <>
              <Divider />
              <div className={`${prefix}-content-title mt-title`}>{app_detail.kit}</div>
              <div className={`${prefix}-content-value`}>
                <span>{app_detail.kit_download}</span>
                {app_detail.kit_download_tip}
              </div>
              <Button icon={<DownloadOutlined />} onClick={handleDownload} className={`${prefix}-kit-download-btn`}>
                {app_detail.kit_download_text}
              </Button>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default Info;
